import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosCommunication } from "./axios";

export const useDeleteCommunicationTemplate = () => {
  const [state, execute, cancel] = axiosCommunication<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (workshopId: ObjectId) => {
      return execute({
        url: `/templates/${workshopId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
